import ImageSideMenu from "./ImageSideMenu";

function ItemSideMenu({ text, num, activeTab, onClick }) {
    return (
        <button
            onClick={() => onClick(num)}
            className={`flex flex-row-reverse items-center
                        my-5 w-60 rounded-lg px-4 py-2 mx-10
                        ${activeTab === num && "bg-purpleDark shadow-xl"}`}
        >
            <ImageSideMenu activeTab={activeTab} num={num} />
            <p
                className={`${activeTab === num ? "text-white font-semibold" : "t-grayDark"} 
                             mr-3 text-sm`}
            >{text}</p>
        </button>
    )
}
export default ItemSideMenu;